import { linkToEditClassAssignment } from "features/teachers/routes/teacher/routes/class/routes/edit-assignment/links";

import {
  linkToCreateAssignmentJourneyDetailsPage,
  linkToCreateAssignmentJourneyExamQuestions,
  linkToCreateAssignmentJourneyInviteParentsPage,
  linkToCreateAssignmentJourneySelectTopics,
  linkToCreateAssignmentJourneySelectType,
  linkToEditAssignmentJourneyDetailsPage,
  linkToEditAssignmentJourneyExamQuestions
} from "./links";

export const CREATE_ASSIGNMENT_FORM_NAME = "create-assignment";
export const TIME_PICKER_INTERVAL = 15; // mins

export enum FlowMode {
  create = "create",
  edit = "edit"
}

export enum AssignmentSpecType {
  courseSections = "course-sections",
  courseUserSections = "course-user-sections",
  courseExamQuestions = "course-exam-questions"
}

export enum AssignmentSteps {
  selectType = "Select type",
  selectTopics = "Select topics",
  examQuestions = "Exam Questions",
  addDetails = "Add details",
  inviteParents = "Invite parents"
}

export enum NextButtonMode {
  next = "next",
  skip = "skip",
  create = "create",
  final = "final"
}

export const AssignmentCreateFlowSteps = [
  {
    link: linkToCreateAssignmentJourneySelectType,
    description: AssignmentSteps.selectType
  },
  {
    link: linkToCreateAssignmentJourneySelectTopics,
    description: AssignmentSteps.selectTopics
  },
  {
    link: linkToCreateAssignmentJourneyExamQuestions,
    description: AssignmentSteps.examQuestions
  },
  {
    link: linkToCreateAssignmentJourneyDetailsPage,
    description: AssignmentSteps.addDetails
  },
  {
    link: linkToCreateAssignmentJourneyInviteParentsPage,
    description: AssignmentSteps.inviteParents
  }
];

export const AssignmentEditFlowSteps = [
  {
    link: linkToEditClassAssignment,
    description: AssignmentSteps.selectTopics
  },
  {
    link: linkToEditAssignmentJourneyExamQuestions,
    description: AssignmentSteps.examQuestions
  },
  {
    link: linkToEditAssignmentJourneyDetailsPage,
    description: AssignmentSteps.addDetails
  }
];

export enum CreateAssignmentSource {
  classOverview = "class-overview",
  classesPage = "classes-page",
  assignmentsOverview = "assignments-overview"
}

export const ASSIGNMENT_TITLE_LIMIT = 80;
